// Careers section: allow only one vacancy open at a time.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.careers__jobs').forEach(function (group) {
    var jobs = group.querySelectorAll('.careers__job');
    jobs.forEach(function (job) {
      job.addEventListener('toggle', function () {
        if (!job.open) return;
        jobs.forEach(function (other) {
          if (other !== job) other.open = false;
        });
      });
    });
  });
});
